exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cond-col:hover .btn-close{visibility:visible;opacity:1}.label-info{background:#673bb7}.label-primary{background:#0351bd}.badge{padding:0 5px;min-width:20px;min-height:20px;line-height:20px;text-align:center;margin:5px 0}.badge.bg-success{background:#4cb050}.btn-close{margin-left:auto;display:block;padding:0px 6px;margin-bottom:3px;top:-5px;position:relative;left:5px;visibility:hidden;opacity:0;transition:0.2s eas-in}.cnod-toggle{position:absolute;color:#fff;background:#CC1A97;padding:3px 12px;border-radius:20px;top:50%;transform:translateY(-50%);right:-92px;z-index:5;min-width:72px}.cnod-toggle:after{content:'';margin-left:7px;margin-top:3px;font:normal normal normal 14px/1 FontAwesome;content:'\\F0DC'}.cnod-toggle:hover{cursor:pointer}.cnod-toggle.or{background:#673bb7}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/rules/new-rule/condition/condition.component.scss
// module id = 1364
// module chunks = 1